import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {ParticleService} from '@core/services/particle.service';
import {SmartGridService} from '@core/services/smart-grid.service';
import {getViewType, ParticleState} from '@shared/store/reducers/particle.reduer';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CollaborationState} from '../../../task-manager/collaboration/store/collaboration.reducer';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {TaskManagerService} from '../../../task-manager/services/task-manager.service';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {FileManagementService} from '@core/services/file-management.service';
import { MatDialog } from '@angular/material/dialog';
import {ProjectState} from '../../../projects/store/reducers/projects.reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {
  GetFieldSectionsAction, User_Specefic_Grid_Filter,
  Dynamic_Grid_Data_Request_Parameters
} from '@shared/store/actions/virtual-grid.actions';
import {SetViewTypeAction} from '@shared/store/actions/particle.actions';
import { Configuration } from '@shared/models/configuration';
import {
  CreateChatConversationCommand
} from '../../../task-manager/collaboration/store/collaboration.command';
import { ContentScope, PlatformCommand } from '@shared/commands/command-base';
import {CreateChatConversationAction} from '../../../task-manager/collaboration/store/collaboration.action';
import {ConversationComponentName} from '../../../task-manager/collaboration/store/collaboration.constants';
import {
  CopyFilingCommand,
  CreateDac6DueDateOccurrencesCommand, CreateFilingCommand, DeleteFilingItemCommand, ExportDAC6Command,
  UpdateFieldValueCommand,
  UpdateFilingDeadlineCommand,
  ArchiveFilingItemCommand, CopyFilingFromExistingCaseCommand, SaveSelectedFilingItemsInLeftSideOfTheTransferboxCommand, CreateFormWithMappingCommand, ArchiveCaseCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand, UnarchiveCaseCommand, ArchiveSingleCaseCommand
} from '../../commands/dac6-reporter.command';
import {take, takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {DialogModel} from '@shared/models/dialog.model';
import {TimeZoneService} from "@core/services/time-zone.service";
import {AddFilingReportCommand, AddFormReportCommand, AddReportCommand} from '../../../data-survey/commands/report.commands';
import { BasketProvider } from '@shared/models/basket-provider';
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {BasketModel} from "@shared/models/common.models";
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {Api} from "@shared/constants/common-field.constants";

@Component({
    standalone: false,
    selector: 'particle-due-dates-content',
  templateUrl: './filing-content.component.html',
  styleUrls: ['./filing-content.component.scss']
})
export class FilingContentComponent implements OnInit, OnDestroy {
  currentBasket: BasketModel;
  currentBasketId: string;
  currentSelectedItems: string[];
  isClose = false;
  flag: boolean;
  deleteDisabled: boolean;
  numberOfTabs$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  hasNoExtraTab = true;
  breadcrumbs: BreadcrumbModel[];
  selectedFieldSectionIndex = 0;
  exportFileName: any[];
  selectedTab: any;
  unsubscribe$ = new Subject<void>();
  private filterModelItem: any;
  private filterModel: any;
  filter$: any;
  tabs: {};
  actions: any[];
  viewType: string;
  filterApplied: boolean;
  endpoint = 'Dac6Api';
  showArchived: boolean;
  applyFilterId: string;
  isInitialBasket = true;
  isTabDataLoaded = true;
  constructor( private router: Router,  private store: Store<IDac6ReporterState>,
               private particleService: ParticleService,
               private smartGridService: SmartGridService,
               private particleStore: Store<ParticleState>,
               protected commandService: CommandService,
               protected particleCacheService: ParticleCacheService,
               private activatedRoute: ActivatedRoute,
               private snackBarService: SnackBarService,
               private collaborationStore: Store<CollaborationState>,
               private dialogService: DialogService,
               private fuseSplashScreenService: FuseSplashScreenService,
               private taskManagerService: TaskManagerService,
               private dac6RepoterApiService: Dac6ReporterApiService,
               private platformSidebarStore: Store<PlatformSidebarState>,
               private fileManagementService: FileManagementService,
               protected projectStore: Store<ProjectState>,
               private queryState: Store<IQueryState>,
               private timeZoneService: TimeZoneService,
               private fileStoreCommonService: FileStoreCommonService
  ) {
    this.showArchived = false;
    this.exportFileName = [
      {
        key: 'Dac6MonthlyFiling.xlsx',
        value: 'Monthly Filing.xlsx'
      },
      {
        key: 'Dac6QuarterlyFiling.xlsx',
        value: 'Quarterly Filing.xlsx'
      },
      {
        key: 'Dac6YearlyFiling.xlsx',
        value: 'Annual Filing.xlsx'
      },
      {
        key: 'Dac6OtherFiling.xlsx',
        value: 'Other Filing.xlsx'
      },
      {
        key: 'Dac6ThirdPartyFiling.xlsx',
        value: 'Third Party Filing.xlsx'
      }
    ];
    this.actions = [
      {
        text: 'Status Setting',
        doAction: this.openStatusSettings,
        self: this
      },
      {
        text: 'Manage Fields',
        doAction: this.manageFields,
        self: this
      },
      {
        text: 'Export',
        doAction: this.export,
        self: this
      }
    ];
    this.tabs = {
      'dac6-mx': [
        {
          id: 0,
          header: 'Monthly Filing',
          index: 0,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6MonthlyFiling',
          filingType: 'monthly',
          relativeUrl: 'dac6-reporter/filing/monthly',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 1,
          header: 'Other Filing',
          index: 1,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6OtherFiling',
          filingType: 'other',
          relativeUrl: 'dac6-reporter/filing/other',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 2,
          header: 'Third Party Filing',
          index: 2,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6ThirdPartyFiling',
          filingType: 'third-party',
          relativeUrl: 'dac6-reporter/filing/third-party',
          createFilingComponent: 'CreateThirdPartyFilingDialogComponent',
          addFilingTitle: 'Add Filing'
        }
      ],
      'dac6-eu': [
        {
          id: 0,
          header: 'Monthly Filing',
          index: 0,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6MonthlyFiling',
          filingType: 'monthly',
          relativeUrl: 'dac6-reporter/filing/monthly',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 1,
          header: 'Quarterly Filing',
          index: 1,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6QuarterlyFiling',
          filingType: 'quarterly',
          relativeUrl: 'dac6-reporter/filing/quarterly',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 2,
          header: 'Annual Filing',
          index: 2,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6YearlyFiling',
          filingType: 'annual',
          relativeUrl: 'dac6-reporter/filing/annual',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 3,
          header: 'Other Filing',
          index: 3,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6OtherFiling',
          filingType: 'other',
          relativeUrl: 'dac6-reporter/filing/other',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 4,
          header: 'Third Party Filing',
          index: 4,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6ThirdPartyFiling',
          filingType: 'third-party',
          relativeUrl: 'dac6-reporter/filing/third-party',
          createFilingComponent: 'CreateThirdPartyFilingDialogComponent',
          addFilingTitle: 'Add Filing'
        }
      ],
      'dac6-gb': [
        {
          id: 0,
          header: 'Monthly Filing',
          index: 0,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6MonthlyFiling',
          filingType: 'monthly',
          relativeUrl: 'dac6-reporter/filing/monthly',
          createFilingComponent: 'CreateFilingDialogComponent',
          addFilingTitle: 'Create Filing'
        },
        {
          id: 1,
          header: 'Third Party Filing',
          index: 1,
          invalidateSubject: new InvalidateSubject(),
          sourceKey : 'Dac6ThirdPartyFiling',
          filingType: 'third-party',
          relativeUrl: 'dac6-reporter/filing/third-party',
          createFilingComponent: 'CreateThirdPartyFilingDialogComponent',
          addFilingTitle: 'Add Filing'
        }
      ]
    };
  }

  private createBreadCrumbs() {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id: 'due-dates',
        title: this.selectedTab.header,
        type: 'due-dates',
        relativeUrl: this.selectedTab.relativeUrl
      }
    ];
  }

  private selectTab(index: number) {
    this.selectedFieldSectionIndex = index;
    this.selectedTab = this.tabs[this.currentBasketId][this.selectedFieldSectionIndex];
    const existingSettings = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters,this.selectedTab.sourceKey);
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.selectedTab.sourceKey,
      {...existingSettings,
        'SOURCE_TYPE': this.selectedTab.sourceKey,
        'SHOW_ARCHIVED': this.showArchived});
    this.createBreadCrumbs();
  }

  private navigateToFiling(filingType: string) {
    this.router.navigateByUrl('dac6-reporter/filing/' + filingType);
  }

  private invalidateSelectedTab() {
    this.selectedTab.invalidateSubject.invalidate();
  }

  ngOnInit() {
    this.currentBasket = Configuration.getCurrentBasket();
    this.currentBasketId = 'dac6-eu';
    if(this.currentBasket) this.currentBasketId = this.currentBasket.id;
    this.currentSelectedItems = [];
    this.flag = false;
    this.deleteDisabled = true;
    this.activatedRoute.params.pipe(takeUntil(this.unSubscribe$)).subscribe((params: any) => {
      if (params && params.filingType) {
        const tab = this.tabs[this.currentBasketId].find(o => o.filingType === params.filingType);
        if (tab) {
          this.selectTab(tab.index);
        } else {
          this.selectTab(0);
        }
      }
      else {
        this.selectTab(0);
      }
      this.hasFilter();
      this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
        this.viewType = viewType;
      });
      if(this.selectedTab){
        this.adustFilterId(this.selectedTab.sourceKey);
      }
      //this.store.dispatch(new GetFieldSectionsAction(this.selectedTab.sourceKey));
      /*this.hasFilter();
      this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
        this.viewType = viewType;
      });
      this.store.dispatch(new GetFieldSectionsAction(this.selectedTab.sourceKey));*/
    });
    QueryProvider.invokeQuery(this.queryState, 'Dac6-CountryCode-Config', {});

    const activityInfo = {type: 'Tool', 'id': 'dac6-filing-manager', 'title': 'Filing', isDefault: true};
    this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }
  adustFilterId(sourceType: string){
    const basketMappedSourceType = Configuration.getBasketMappedSourceType(sourceType);
    if(basketMappedSourceType !== this.applyFilterId){
      this.applyFilterId = null;
      setTimeout(()=>{
        this.applyFilterId = basketMappedSourceType;
      },100);
    }
  }
  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }

  onTabIndexChange($event) {
    const tab = this.tabs[this.currentBasketId][$event];
    this.navigateToFiling(tab.filingType);
  }


  createForm(filingItem: any, templateId: string) {
    let selectionKey = 'create-form-with-mapping';
    let preCommand = new SaveSelectedFilingItemsInLeftSideOfTheTransferboxCommand(selectionKey, filingItem.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate=>{
      if(prestate){
        this.openTransferboxToCreateFiling(filingItem, selectionKey, templateId);
      }
    });
  }
  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
  }
  openTransferboxToCreateFiling(filingItem: any,  selectionKey: string, templateId: string){
    let input = {
      ['SELECTION_KEY'] : selectionKey,
      ['SOURCE_TYPE']: this.selectedTab.sourceKey,
      ['FILING_ITEM_ID']: filingItem.id,
      ['ITEM_ID']: filingItem.id
    };
    let filterId = `${selectionKey}${filingItem.id}`;
    const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
      filterId: filterId,
      filterTemplateId: 'create-form-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.minWidth = '80%';
    dialogModel.maxWidth = '1500px';

    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          let command = new CreateFormWithMappingCommand(filterId, selectionKey, filingItem.id, templateId);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).subscribe(state => {
            this.fuseSplashScreenService.hide();
            this.router.navigate([`dac6-reporter/filing-manager/forms/${state.Payload}`]);
          });
        }
      });
  }

  startConversationActivity(event)
  {
    let viewDocumentCommand = new PlatformCommand('OpenConversationActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'Form' && event.value) {
      if (event.value.tags && event.value.tags.length) {
        const formId = event.value.tags[0];
        console.log(this.activatedRoute);
        this.router.navigate([`dac6-reporter/filing-manager/forms/${formId}`], {
          queryParams: {'arrangementGuid': event.item.cells['ArrangementGUID'].value}
        });
      } else {
        this.createForm(event.item, event.value.id);
        /*if(event.item.cells['Jurisdiction'].value === 'PL'){
         const url = `dac6-reporter/filing-manager/forms/create/${event.item.id}/${event.value.id}`;
         this.router.navigate( [url], {
         queryParams: {'arrangementGuid': event.item.cells['ArrangementGUID'].value, 'sourceType': event.item.cells['SourceType'].value}
         });
         } else{
         this.createForm(event.item, event.value.id);
         }*/
      }

      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.cells['CaseGUID'].value}`);
      return;
    }

    switch (event.action.id) {
      case 'Open':
        this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.cells['CaseGUID'].value}`);
        break;
      case 'OpenCaseFolder':
        let viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand','Dac6Api');
        var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
        viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
        // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
        viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
        this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
            console.log('commandState', response);
          },
          error => {
            console.error('Failed to basket manage section', error);
          });
        this.navigateToCaseFolder(event);
        break;

      case 'AttachTask':
        // this.attachTask(event);
        break;
      case 'OpenTask':
        // this.openTask(event);
        break;
      case 'Reset':
        this.reset(event);
        break;
      case 'Refresh':
        this.invalidateSelectedTab();
        break;
      case 'Edit':
        this.edit(event);
        break;
      case 'SetActive':
        // this.setActive(event);
        break;
      case 'Occurrances':
        // this.showOccurrances(event);
        break;
      case 'Task':
        this.showTask(event);
        break;
      case 'Start Conversation':
        this.startConversationActivity(event);
        this.getChatForThisCase(event);
        break;
      case 'CreateReport':
        this.createReport(event.item)
        break;
      case 'CreateACopy':
        this.copyFilling(event.item)
        break;
      case 'Delete':
        this.delete(event);
        break;
      case 'Archive':
        this.archiveSingle(event.item.cells['CaseGUID'].value);
        break;
      case 'UnarchiveCase':
        this.unarchiveCase(event.item.cells['CaseGUID'].value);
        break;
      case 'Copy':
        this.copyCase(event);
        break;
      case 'ViewActivity':
        this.trackCaseActiviy(event);
        break;
    }
    console.log('onGridCellValueChange', event);
  }
  getChatForThisCase(event) {
    console.log('on filinn', event);
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseId'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseId'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  showTask(event) {
    if (event.item.cells[event.fieldDefinition.key]
      && event.item.cells[event.fieldDefinition.key].value
      && event.item.cells[event.fieldDefinition.key].value.taskId) {
      this.taskManagerService.openTaskByTaskId(event.item.cells[event.fieldDefinition.key].value.taskId, 'COMPANY').subscribe(state => {
        if(state){
          const value = event.fieldDefinition.dataType === 'Boolean' ? this.getBoolean(event.item.cells[event.fieldDefinition.key].value) : event.item.cells[event.fieldDefinition.key].value;
          if(state.card && state.card.status && value.hasOwnProperty('taskStatus')){
              value.taskStatus = state.card.status;
          }
          if(state.card && state.card.title && value.hasOwnProperty('taskTitle')){
            value.taskTitle = state.card.title;
          }
          let displayFieldValue = '';
          if(event.item.cells[`${event.fieldDefinition.key}DisplayText`]){
            displayFieldValue = event.item.cells[`${event.fieldDefinition.key}DisplayText`];
          }
          this.updateFieldValue(event.item.id, event.fieldDefinition.key, value, displayFieldValue);
        }
      });
    } else {
      this.fuseSplashScreenService.show();
      const command = new CreateDac6DueDateOccurrencesCommand(event.item.id, event.fieldDefinition.key, event.fieldDefinition.header, null);
      this.commandService.executeCommand(command)
        .pipe().subscribe(commandState => {
        this.invalidateSelectedTab();
        this.fuseSplashScreenService.hide();
      });
    }
  }

  manageFields() {
    this.router.navigateByUrl(`dac6-reporter/filing/manage-section/${this.selectedTab.sourceKey}`);
  }
  onSelectedTabChanged(event){

  }
  openStatusSettings() {
    this.dac6RepoterApiService.getDac6BoardId().pipe(takeUntil(this.unsubscribe$)).subscribe((selectedBoardId: any) => {
      if (selectedBoardId) {
        this.taskManagerService.openTaskStatusSettings(selectedBoardId, 1).pipe(takeUntil(this.unsubscribe$)).subscribe(xx => {
          this.invalidateSelectedTab();
        });
      }
    });
  }


  hasFilter() {
    this.dac6RepoterApiService.getHasFilter(this.selectedTab.sourceKey).pipe(takeUntil(this.unsubscribe$)).subscribe((hasfilter: any) => {
      if (hasfilter) {
        this.filterApplied = hasfilter;
      }
    });
  }

  edit(event: any) {
    if(event.fieldDefinition.key === 'FilingAttachment'){
      event.fieldDefinition.metaData['DirectoryPath'] =
        event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]',event.item.cells['CaseId'].value);
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '600px', '600px', this.selectedTab.sourceKey)
      .subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {
          if (event.fieldDefinition.key === 'DAC6FilingDeadline') {
            const value = event.item.cells[event.fieldDefinition.key].value.dueDate;
            const command = new UpdateFilingDeadlineCommand(event.item.id, event.fieldDefinition.key, value);
            this.commandService.executeCommand(command).pipe().subscribe(commandState => {
              console.log(commandState);
              this.invalidateSelectedTab();
            });
          } else {
            const value = event.fieldDefinition.dataType === 'Boolean' ? this.getBoolean(event.item.cells[event.fieldDefinition.key].value) : event.item.cells[event.fieldDefinition.key].value;
            let displayFieldValue = '';
            if(event.item.cells[`${event.fieldDefinition.key}DisplayText`]){
              displayFieldValue = event.item.cells[`${event.fieldDefinition.key}DisplayText`];
            }
            this.updateFieldValue(event.item.id, event.fieldDefinition.key, value, displayFieldValue);
          }
        }
      });
  }

  updateFieldValue(filingId: string, fieldKey: string, value: any, displayText: string){
    const command = new UpdateFieldValueCommand(filingId, fieldKey, value, displayText);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
    });
  }

  getBoolean(value: string) {
    return value === 'true' || value === 'Yes' || value === 'yes';
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  export() {
    const sourceType = this.selectedTab.sourceKey;
    this.fuseSplashScreenService.show();
    const filtersObject = this.particleCacheService.getUserPreferenceGridSetting(User_Specefic_Grid_Filter, sourceType);
    const filters = Object.values(filtersObject);
    const parametersObject = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
    this.commandService.executeCommand(new ExportDAC6Command(sourceType, filters, parametersObject)).subscribe(response => {
      this.fileManagementService.downloadClientFileWithId(response.Payload.FileId).subscribe(payload => {
        this.fuseSplashScreenService.hide();
        const exportFileName = this.exportFileName.find(item=>item.key === response.Payload.FileName).value;
        this.fileManagementService.openSaveFileWindow(payload, exportFileName);
      });
    });
  }

  reset(event: any) {
    const command = new UpdateFilingDeadlineCommand(event.item.id, event.fieldDefinition.key, null);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
    });
  }

  delete(event: any) {
    this.fuseSplashScreenService.show();
    const command = new DeleteFilingItemCommand(event.item.id);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
      this.fuseSplashScreenService.hide();
    });
  }

  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = "Archive";
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        let command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  unarchiveCase(caseGuid: string) {
    const message = "You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.";
    const question = "Are you sure you want to unarchive this DAC6 Case?";
    this.dialogService.showConfirmDialog("Unarchive", "Unarchive", "Cancel", message, question ).subscribe(data => {
    if (data.action === 'OK') {
    var command = new UnarchiveCaseCommand(caseGuid);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).subscribe(state => {
        this.invalidateSelectedTab();
        this.fuseSplashScreenService.hide();
    });
  }});
}

  archive(event: any, value: boolean) {
    // console.log('Archived: ', event.item.cells['Archived'].value) ;
    if( value ){
      // Archive
      const dialogModel = DialogModel.create('Archive',
        'ArchiveUnarchiveDialogComponent',
        event , '600px', '700px');
      dialogModel.okCaption = 'Archive' ;
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
        if (data.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new ArchiveFilingItemCommand(event.item.id, value);
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            this.invalidateSelectedTab();
            this.fuseSplashScreenService.hide();
          });
        }
        else{
          this.invalidateSelectedTab();
        }
      });
    }
    else{
      // Unarchive
      const message = "You can unarchive this filing record if you need to make additional edits, or if it was archived by mistake. Please ensure that any associate Task and Reports are updated and re-opened as required.";
      const question = "Are you sure yoiu want to unarchive this filing record?";
      this.dialogService.showConfirmDialog("Unarchive", "Unarchive", "Cancel", message, question ).subscribe(data => {
        if (data.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new ArchiveFilingItemCommand(event.item.id, value);
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            console.log(commandState);
            this.invalidateSelectedTab();
            this.fuseSplashScreenService.hide();
          });
        }
      });
    }
  }

  bulkArchive(){
    let sourceKeyLower = this.selectedTab.sourceKey.toLowerCase();
    let selectionKey = `${sourceKeyLower}-archive-cases`;
    let input = {
      ['SELECTION_KEY'] : selectionKey,
      ['ITEMS_SOURCE_TYPE']: this.selectedTab.sourceKey
    };
    let filterId = selectionKey;
    const basketSourceType = BasketProvider.getBasketMappedSourceType(this.selectedTab.sourceKey);
    let preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(selectionKey, filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate=>{
      if(prestate){
        const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
          filterId: selectionKey,
          filterTemplateId: `${sourceKeyLower}-archive-filter`,
          apiKey: 'Dac6Api',
          input: input
        });
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';
        dialogModel.okCaption = "Next";
        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(filterId, selectionKey)
            }
          });
      }
    });
  }

  showArchiveDialog(filterId, selectionKey){
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = "Archive";
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log("Clicked Okay");
        console.log(data.data.input['comment']);
        let command = new ArchiveCaseCommand(filterId, selectionKey, this.selectedTab.sourceKey, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  sendShowArchivedActivityCommand(tabSourceKey) {
    let showArchivedCommand = new PlatformCommand('ShowArchivedCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(tabSourceKey);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  sendCreateReportActivityCommand(sourceType,title,caseId) {
    let showArchivedCommand = new PlatformCommand('CreateReportActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['Title'] = title;
    showArchivedCommand.fieldValues['CaseId'] = caseId;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  showArchivedChanged(){
    this.fuseSplashScreenService.show();
    console.log("showArchivedChanged");
    for (var _i = 0; _i < this.tabs[this.currentBasketId].length; _i++) {
      var tab = this.tabs[this.currentBasketId][_i];
      const config = Configuration.getSmartGridConfig(tab.sourceKey);
      config['Parameters']['SHOW_ARCHIVED'] = this.showArchived;
      this.sendShowArchivedActivityCommand(tab.sourceKey);
      const gridParams = {...config.Parameters, 'SOURCE_TYPE': tab.sourceKey}
      this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, tab.sourceKey, gridParams);
    }
    this.invalidateSelectedTab();
    this.fuseSplashScreenService.hide();
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].value;
      relativePath = relativePath.replace('[CASE_ID]', caseId);

      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });
      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);

    }
  }
  createReport(item: any) {
    const dialogModel = DialogModel.create('Add Report', 'AddReportComponent',
      {title: '', description: ''}
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.commandService.executeCommand(new AddReportCommand(state.data.input.title, state.data.input.description))
          .pipe(take(1)).subscribe(commandState => {
          this.sendCreateReportActivityCommand(item.type,state.data.input.title,item.id);
          this.router.navigateByUrl(`dac6-reporter/reports/participants/${commandState.Payload.Id}/${item.id}`);
        });
      }
    });
  }
  goCorrespondingFilingTab(filingSourceType: string ) {
    const tab = this.tabs[this.currentBasketId].find(o => o.sourceKey === filingSourceType);
    this.selectTab(tab.index);
  }

  createFiling() {
    const dialogModel = DialogModel.create('Create Filing',
      this.selectedTab['createFilingComponent'],
      {'caseType': 'Filing'}, '600px', '700px', true);
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe((data: any) => {
      if (data.action === 'OK') {
        if(!data.data.input.cancelFiling){
          this.goCorrespondingFilingTab(data.data.input.filingSourceType);
          //const command = new CreateFilingCommand(data.data.input.reportingCountryCode, data.data.input.formTemplateId, data.data.input.title,
          //  new Date(this.timeZoneService.dateTostringWithoutUTC(data.data.input.dueDate)));
          this.commandService.executeCommand(data.data.input['CreateFilingCommand']).pipe().subscribe(commandState => {
            console.log(commandState);
            this.invalidateSelectedTab();
          });
        }
      }
    });
  }
  close() {
    this.isClose = true;
  }

  copyFilling(item: any){
    const dialogModel = DialogModel.create('Create Copy for Re-submission',
      'CopyFilingDialogComponent',
      {'title': item.cells.Title ? item.cells.Title.value + " (Re-submission)":''}, '600px', '700px', false);
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        this.fuseSplashScreenService.show();
        const command = new CopyFilingCommand(item.id,data.data.input['isArchive'], true,data.data.input['title'], this.selectedTab.sourceKey);
        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  private copyCase(event: any) {
    var dialogModelTitle = "Copy Case (" + event.item.cells.CaseId.displayText + ")";
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent', {'caseId': event.item.cells.CaseId.displayText, 'caseType': 'Filing', disableTypeChange: true, 'filedPeriodTitle': event.item.cells.FiledPeriodTitle.displayText, 'isReadOnly': event.item.isReadOnly, 'isArcived' : event.item.cells.Archived.value},
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Filing':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase,'filingmodel', 'Dac6MonthlyFiling', res, event.item.id, res.data.input.copyCount);
            } else {
              this.copyFilingFromExistingCaseCommand(event.item.id , res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount);
            }
            break;
        }
      }

    });
  }

  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'Dac6MonthlyFiling':
            this.copyFilingFromExistingCaseCommand(caseData.data.input.selectedCase, caseData.data.input.archiveExisting, false, caseData.data.input.copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }
  copyFilingFromExistingCaseCommand(existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CopyFilingFromExistingCaseCommand(existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.invalidateSelectedTab();
    });
  }

  manageSection(sourceType:string) {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', Api.DAC6);
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType(sourceType);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to filing managesection ', error);
      });
  }
  onBasketChange(event){
    if(!this.isInitialBasket){
      this.adustFilterId(this.selectedTab.sourceKey);
    }
    this.isInitialBasket = false;

    this.isTabDataLoaded = false;
    this.currentBasket = event;
    this.currentBasketId = this.currentBasket.id;
    let tab = this.tabs[this.currentBasketId].find(o => o.filingType === this.selectedTab.filingType);
    if (!tab) {
      tab = this.tabs[this.currentBasketId][0];
    }
    setTimeout(() => {
      this.selectTab(tab.index);
      this.isTabDataLoaded = true;
      this.navigateToFiling(tab.filingType);
    }, 500);
  }
}

